import React, { useState } from 'react';
import { Offcanvas, Badge, Nav } from 'react-bootstrap';
import { MdClose, MdBusiness, MdEmail, MdPhone, MdLocationOn, MdAttachMoney, MdDescription, MdCalendarToday, MdPeople } from 'react-icons/md';
// import UserListTable from '../pages/OEMPartners/common/UserListTable';

const OEMDetailsOffcanvas = ({ isOpen, onClose, partner }) => {
  const [activeTab, setActiveTab] = useState('details');
  
  if (!partner) return null;

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const formatAmount = (amount, currency) => {
    // JPY doesn't use cents, so don't divide by 100
    if (currency === 'JPY') {
      return amount;
    }
    // Other currencies (USD, SGD, HKD, AUD, EUR) use cents
    const value = amount / 100;
    return value % 1 === 0 ? value.toString() : value.toFixed(2);
  };
  const handleClose = () => {
    setActiveTab('details');
    onClose();
  };

  return (
    <Offcanvas show={isOpen} onHide={handleClose} placement="end" style={{ width: '500px' }}>
      <Offcanvas.Header className="border-bottom">
        <Offcanvas.Title className="d-flex align-items-center">
          OEM Partner Details
        </Offcanvas.Title>
        <button 
          type="button" 
          className="btn-close" 
          onClick={onClose}
          aria-label="Close"
        />
      </Offcanvas.Header>
      
      <Offcanvas.Body className="p-0">
        {/* Header Section with Logo and Status */}
        <div className="bg-light p-3 border-bottom">
          <div className="d-flex align-items-center">
            {partner.logo && (
              <img 
                src={partner.logo} 
                alt="Company Logo" 
                className="rounded me-3"
                style={{width: '100px', height: '60px', objectFit: 'contain', border: '1px solid #ddd' ,background: 'linear-gradient(135deg, #1e40af, #3b82f6)'}}
              />
            )}
            <div>
              <h6 className="mb-0">{partner.companyName}</h6>
              <Badge bg={partner.status === 'active' ? 'success' : 'secondary'}>
                {partner.status?.toUpperCase()}
              </Badge>
            </div>
          </div>
        </div>
        {/* Tab Content */}
          <>
            {/* Contact Information */}
            <div className="p-3 border-bottom">
              <h6 className="text-muted mb-3">Contact Information</h6>
              <div className="row g-1">
                <div className="col-12">
                  <div className="d-flex align-items-center">
                    <MdEmail className=" text-muted me-2" style={{fontSize:"12px"}} />
                    <span>{partner.email}</span>
                  </div>
                </div>
                <div className="col-6">
                  <div className="d-flex align-items-center">
                    <span className="text-muted me-2 "  style={{fontSize:"10px"}}>👤</span>
                    <span>{partner.firstName} {partner.lastName}</span>
                  </div>
                </div>
                <div className="col-6">
                  <div className="d-flex align-items-center" >
                    <MdPhone className=" text-muted me-2" style={{fontSize:"12px"}} />
                    {partner.flagLink && partner.countryCode ? (
                      <div className="d-flex align-items-center">
                        <span style={{ fontSize: "", marginRight: "4px" }}>({partner.countryCode})</span>
                        <span>{partner.contactNumber}</span>
                      </div>
                    ) : (
                      <span>{partner.contactNumber}</span>
                    )}
                  </div>
                </div>
                <div className="col-12">
                  <div className="d-flex align-items-center">
                    <MdLocationOn className=" text-muted me-2"  style={{fontSize:"14px"}}/>
                    <span>{partner.country} ({partner.currency})</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Plan Details - Only show for Single scan type */}
            {partner.scanType === "Single" && (
              <div className="p-3 border-bottom">
                <h6 className="text-muted mb-3">Plan Details</h6>
                {partner.planDetails && partner.planDetails.length > 0 ? (
                  partner.planDetails.map((plan, index) => (
                    <div key={index} className="card mb-2">
                      <div className="card-body p-3">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <h6 className="card-title mb-0">{plan.planName}</h6>
                          <Badge bg="primary">{plan.currency} {formatAmount(plan.amount, plan.currency)}</Badge>
                        </div>
                        <small className="text-muted">Product ID: {plan.stripeProductId}</small>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-muted">No plan details available</p>
                )}
              </div>
            )}

            {/* Stripe Product IDs - Only show for Single scan type */}
            {partner.scanType === "Single" && (
              <div className="p-3 border-bottom">
                <h6 className="text-muted mb-3">Stripe Product IDs</h6>
                {partner.stripeProductId && partner.stripeProductId.length > 0 ? (
                  <div className="d-flex flex-wrap gap-3">
                    {partner.stripeProductId.map((productId, index) => (
                      <Badge key={index} bg="outline-primary" className="text-dark border">
                        {productId}
                      </Badge>
                    ))}
                  </div>
                ) : (
                  <p className="text-muted">No product IDs available</p>
                )}
              </div>
            )}

            {/* Description */}
            <div className="p-3 border-bottom">
              <h6 className="text-muted mb-3">
                <MdDescription className="me-2" />
                Almata Shared Description
              </h6>
              <p className="mb-0">{partner.almataSharedDiscription || 'No description available'}</p>
            </div>

            {/* Payment Information */}
            <div className="p-3 border-bottom">
              <h6 className="text-muted mb-3">
                <MdAttachMoney className="me-2" />
                Payment Information
              </h6>
              <div className="row g-2">
                <div className="col-6">
                  <small className="text-muted">Payment Currency</small>
                  <div>{partner.paymentCurrency}</div>
                </div>
                <div className="col-6">
                  <small className="text-muted">Password</small>
                  <div className="d-flex align-items-center">
                    <span className="me-2">••••••••••••</span>
                    <small className="text-success">Available</small>
                  </div>
                </div>
              </div>
            </div>

            {/* Timestamps */}
            <div className="p-3">
              <h6 className="text-muted mb-3">
                <MdCalendarToday className="me-2" />
                Timeline
              </h6>
              <div className="row g-2">
                <div className="col-12">
                  <small className="text-muted">Created At</small>
                  <div>{formatDate(partner.createdAt)}</div>
                </div>
                <div className="col-12">
                  <small className="text-muted">Last Updated</small>
                  <div>{formatDate(partner.updatedAt)}</div>
                </div>
              </div>
            </div>
          </>
       
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default OEMDetailsOffcanvas;